var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TenderPlug',{attrs:{"title":_vm.$t('No archived tenders yet'),"description":_vm.$t(
      'You can add any of the active tenders to the archive and they will appear in this section'
    )},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('ArchiveIcon')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }